export default __webpack_public_path__ + "static/media/8_Premiacion_empresas.271f2bc8.mp3";